import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { FinanceData } from '../types';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

interface DistributionExpensesProps {
  data: FinanceData[];
}

const customColors = [
  'rgba(203, 229, 78, 1)',
  'rgba(255, 202, 2, 1)',
  'rgba(93, 149, 234, 1)',
  'rgba(241, 133, 1, 1) ',
];

export const DistributionOfExpensesbyCategoryTable: React.FC<DistributionExpensesProps> = ({ data }) => {
  const { t } = useTranslation();
  const sortedData = [...data].sort((a, b) => a.year - b.year);

  const chartData = sortedData.map(item => ({
    год: item.year.toString(),
    [t('salary')]: item.expensesSalary,
    [t('Real estate maintenance')]: item.expensesRealEstateMaintenance,
    [t('Maintenance of movable property')]: item.expensesMovableProperty,
    [t('other')]: item.expensesOther,
  }));

  return (
    <div className={styles.container}>
      <div className={styles.chartContainer}>
        <h2 className={styles.title}>{t('Distribution of expenses by categories (by years)')}</h2>
        <ResponsiveContainer>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="год" />
            <YAxis />
            <Tooltip 
              contentStyle={{
                background: '#fff',
                border: 'none',
                borderRadius: '8px',
                boxShadow: '4px 4px 4px 4px rgba(0, 0, 0, 0.1)',
                padding: '10px'
              }}
            />
            <Legend 
              wrapperStyle={{
                fontSize: '13px',
              }}
              iconSize={10}
              iconType="circle"
              verticalAlign="bottom"
              align="center"
            />
            <Bar barSize={60} dataKey={t('salary')} fill={customColors[0]} stackId="a" />
            <Bar barSize={60} dataKey={t('Real estate maintenance')} fill={customColors[1]} stackId="a" />
            <Bar barSize={60} dataKey={t('Maintenance of movable property')} fill={customColors[2]} stackId="a" />
            <Bar barSize={60} dataKey={t('other')} fill={customColors[3]} stackId="a" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}